import { Cpu, Fan, Radio, Zap, Factory, Cog, Gauge, Network } from 'lucide-react';

const IMG = 'https://static.prod-images.emergentagent.com/jobs/2f8d28b7-4ebe-4317-8ba5-2c9c19007ec7/images/';
export const SIM_HERO_IMG = `${IMG}5e3ad7b114d856260cf321e3471c6f665bceb259d3d6bea8696b94e7a6760b3c.jpeg`;
export const SIM_CTA_LAPTOP = `${IMG}29d5051184eb215d6e74dc638ead20693ae572006e806bf50727e72e49090814.jpeg`;
export const SIM_CTA_PLC = `${IMG}5067c5df07ed30fd7c1246a9cd15f8047697baf9db1afd2c700e1c3a9180b7d3.jpeg`;
export const SIM_FALLBACK_IMG = `${IMG}bac7a4932f8ae610690072c545c435304a60cd2089652d4c38ad527de1f8a54e.jpeg`;

export const SIM_ICONS = {
  plc: { Icon: Cpu, cls: 'bg-blue-50 text-blue-600', ar: 'PLC', en: 'PLC' },
  motor: { Icon: Fan, cls: 'bg-sky-50 text-sky-600', ar: 'محرك', en: 'Motor' },
  sensor: { Icon: Radio, cls: 'bg-rose-50 text-rose-500', ar: 'حساس', en: 'Sensor' },
  circuit: { Icon: Zap, cls: 'bg-amber-50 text-amber-500', ar: 'دارة', en: 'Circuit' },
  factory: { Icon: Factory, cls: 'bg-emerald-50 text-emerald-600', ar: 'مصنع', en: 'Factory' },
  cog: { Icon: Cog, cls: 'bg-slate-100 text-slate-600', ar: 'ترس', en: 'Cog' },
  gauge: { Icon: Gauge, cls: 'bg-violet-50 text-violet-600', ar: 'عدّاد', en: 'Gauge' },
  network: { Icon: Network, cls: 'bg-teal-50 text-teal-600', ar: 'شبكة', en: 'Network' },
};
export const iconFor = (key) => SIM_ICONS[key] || SIM_ICONS.cog;

export const LEVELS = [
  { value: 1, ar: 'المستوى الأول', en: 'Level 1' },
  { value: 2, ar: 'المستوى الثاني', en: 'Level 2' },
  { value: 3, ar: 'المستوى الثالث', en: 'Level 3' },
];
export const levelLabel = (v, lang) => {
  const l = LEVELS.find(x => x.value === Number(v)) || LEVELS[0];
  return lang === 'ar' ? l.ar : l.en;
};

export const normalizeSim = (s) => ({
  id: s.id,
  title: { ar: s.titleAr, en: s.titleEn },
  excerpt: { ar: s.descAr, en: s.descEn },
  categories: [s.category_id || 'none'],
  image: s.image || SIM_FALLBACK_IMG,
  level: s.level || 1,
  is_free: !!s.is_free,
  hasHtml: !!s.has_html,
  created: s.created_at || '',
});

export const errText = (e, fb = 'حدث خطأ') => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map(x => x?.msg || '').filter(Boolean).join(' — ') || fb;
  return typeof d === 'string' ? d : fb;
};
